// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Authentication disabled - imports commented out
// import RequireAuth from './components/RequireAuth';
// import RequireRole from './components/RequireRole';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignOverview from './pages/CampaignOverview';
import Leads from './pages/Leads';
import LeadOverview from './pages/LeadOverview';
import Agents from './pages/Agents';
import CallStudio from './pages/CallStudio';
import SmartDialer from './pages/SmartDialer';
import ScriptBuilder from './pages/ScriptBuilder';
import SMSInbox from './pages/SMSInbox';
import SLAITraining from './pages/slai-training/SLAITraining';
import Reports from './pages/Reports';
import Settings from './pages/Settings/Settings';
import WorkflowBuilder from './pages/workflow-builder/WorkflowBuilder';
import TenantManagement from './pages/TenantManagement/TenantManagement';
import AgentCommandCenter from "./pages/AgentCommandCenter/AgentCommandCenter";
import AgentNotifications from "./pages/AgentNotifications/AgentNotifications";
import DialerAdminPanel from './pages/DialerAdminPanel/DialerAdminPanel';

const App = () => {
    return (
        <Router>
            <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* All routes are now accessible without authentication */}
                <Route
                    path="*"
                    element={
                        <div className="dashboard-app">
                            <Sidebar />
                            <div className="main">
                                <TopBar />
                                <Routes>
                                        <Route path="/dashboard" element={<Dashboard />} />

                                        {/* Previously Super Admin Only Routes - now accessible to all */}
                                        <Route path="/tenant-management" element={<TenantManagement />} />

                                        {/* Previously Admin Routes - now accessible to all */}
                                        <Route path="/settings" element={<Settings />} />

                                        {/* Regular Routes */}
                                        <Route path="/campaigns" element={<Campaigns />} />
                                        <Route path="/campaigns/:id/overview" element={<CampaignOverview />} />
                                        <Route path="/leads" element={<Leads />} />
                                        <Route path="/leads/:id" element={<LeadOverview />} />
                                        <Route path="/agents" element={<Agents />} />
                                        <Route path="/call-studio" element={<CallStudio />} />
                                        <Route path="/smart-dialer" element={<DialerAdminPanel />} />
                                        <Route path="/script-builder" element={<ScriptBuilder />} />
                                        <Route path="/sms-inbox" element={<SMSInbox />} />
                                        <Route path="/slai-training" element={<SLAITraining />} />
                                        <Route path="/reports" element={<Reports />} />

                                        {/* Workflow Builder Routes */}
                                        <Route path="/workflow-builder/new" element={<WorkflowBuilder />} />
                                        <Route path="/workflow-builder/:id" element={<WorkflowBuilder />} />

                                        <Route path="/agent-command-center" element={<AgentCommandCenter />} />
                                        <Route path="/agent-notifications" element={<AgentNotifications />} />

                                        {/* Default redirect to dashboard */}
                                        <Route path="/" element={<Navigate to="/dashboard" />} />
                                        <Route path="*" element={<Navigate to="/dashboard" />} />
                                    </Routes>
                                </div>
                            </div>
                    }
                />
            </Routes>
        </Router>
    );
};

export default App;